"use client";

import { useAuthStore } from "@/stores/authStore";

export function useUiTheme(): "light" | "dark" {
  const uiTheme = useAuthStore((s) => s.user?.ui_theme);

  return uiTheme === "dark" ? "dark" : "light";
}

export function useIsDarkMode(): boolean {
  return useUiTheme() === "dark";
}
